import React from "react";

import { Link } from "react-router-dom";
const Slide2 = () => {
  const bgimg = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Net-Banking-New.png";
  const netBanking = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Net_Banking_Post.png";

  const textColor = {
    color: "#9E1B1E",
  };
  return (
    <section className="overview-area">
      <Link to="https://netbanking.izb.co.zm/ReachInet/IZB-web/inet/index.html" target="_blank">
        <img src={netBanking} className="d-md-none d-sm-block" alt="" />
      </Link>

      <div className="container">
        <div className="row">
          <div className=" col-md-6 col-xl-6">
            <div className="overview-content-box-one d-none d-md-block">
              <img
                src={bgimg}
                width={500}
                style={{ backgroundColor: "#FFF5E7", objectFit: "contain" }}
                alt=""
              />
            </div>
          </div>
          <div className="col-xl-6 col-md-6 ">
            <div className="overview-content-box-two h-100 d-flex flex-column justify-content-center d-none d-md-block">
              <div className="inner-title">
                <h2 style={textColor}>Indo NXT Corporate Banking</h2>
                <p className="my-4">
                  Manage your account conveniently through the Internet.
                  Up-to-the-second details of your account Access anytime, from
                  anywhere No queues to stand in, or turns to wait for.
                </p>
                <p className="mb-5">
                  View Account Balances Monitor cleared transactions, forex
                  rates inquiry vew, print and store electronic copies of your
                  statements
                </p>
                <h6 className="mb-4">
                  {" "}
                  <strong> Click Below for Indo NXT Corporate Banking:</strong>
                </h6>
              </div>
              <div>
                <Link to="https://netbanking.izb.co.zm/ReachInet/IZB-web/inet/index.html" target="_blank">
                  <button
                    className="btn btn-danger text-white fs-6"
                    style={{ backgroundColor: "#9E1B1E" }}
                  >
                    Retail / Corporate
                  </button>
                </Link>
                {/* <Link to="/NetBanking">
                  <button
                    className="btn btn-danger w-25 text-white fs-6 ms-3"
                    style={{ backgroundColor: "#9E1B1E" }}
                  >
                    Corporate
                  </button>
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Slide2;
